import { withBase, withoutBase, withoutTrailingSlash } from 'ufo';

/** Resolve a router path ('/organizations') to a document path ('/accounts/organizations'). Absolute URLs pass through. */
export const toAppHref = (path: string, baseURL: string) => {
  if (!path || /^https?:\/\//i.test(path)) return path;
  return withBase(path, baseURL);
};

export const hardReplace = (path: string, baseURL: string) => window.location.replace(toAppHref(path, baseURL));

/** Inverse of toAppHref — strip the prefix back off before handing a path to router.push,
 * which resolves against un-prefixed route paths and must not receive the base itself. */
export const stripAppHref = (href: string, baseURL: string) => withoutBase(href, baseURL);

/** Cookie path for the post-sign-in return path: the base without its trailing slash, so the
 * cookie is scoped to this app once it is served under a prefix and still matches the bare base. */
export const redirectCookiePath = (baseURL: string) => withoutTrailingSlash(baseURL || '/') || '/';
